const blockSliderZoom = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const blocks = document.querySelectorAll(".block-slider-zoom__section");
    if (blocks.length > 0) {
      blocks.forEach((block) => {
        const slider = new Swiper(block.querySelector(".swiper"), {
          slidesPerView: 1,
          spaceBetween: 12,
          centeredSlides:true,
          loop: true,
          navigation: {
            nextEl: block.querySelector(".swiper-button-next"),
            prevEl: block.querySelector(".swiper-button-prev"),
          },
          pagination: {
            el: block.querySelector(".swiper-pagination"),
            clickable: true,
          },
          breakpoints: {
            1200: {
              slidesPerView: 3,
              spaceBetween: 12,
            },
          },
        });
      });
    }
  });
};

export default blockSliderZoom;
